// 頁面快捷鍵（SPEC #vms-web-973「鍵盤」，VMS UX 評審 2026-10-13 P2-3）：游標在輸入框、下拉選單、可編輯區，
// 對話框開著，或按著 ⌘ / Ctrl / Alt 時不攔截（不搶使用者在打字或用瀏覽器快捷鍵）。
import { useEffect, useState } from 'react';

export function ignoreHotkey(e: KeyboardEvent): boolean {
  if (e.metaKey || e.ctrlKey || e.altKey || e.isComposing) return true;
  const el = e.target as HTMLElement | null;
  if (el && (el.isContentEditable || /^(INPUT|TEXTAREA|SELECT)$/.test(el.tagName))) return true;
  return !!document.querySelector('dialog[open], [role="dialog"]');
}

/** 影像牆版型快捷鍵：1 / 2 / 3 / 4 = 1 / 4 / 9 / 16 格。 */
export const GRID_KEYS: Record<string, 1 | 4 | 9 | 16> = { '1': 1, '2': 4, '3': 9, '4': 16 };
export const gridKeyOf = (n: number): string | undefined => Object.entries(GRID_KEYS).find(([, v]) => v === n)?.[0];

/** 視窗寬度符不符合 media query（窄螢幕影像牆最多 2 欄，P2-2）。 */
export function useMedia(query: string): boolean {
  const get = () => typeof window !== 'undefined' && !!window.matchMedia?.(query).matches;
  const [m, setM] = useState(get);
  useEffect(() => {
    const mq = window.matchMedia?.(query);
    if (!mq) return;
    const on = () => setM(mq.matches);
    on();
    mq.addEventListener?.('change', on);
    return () => mq.removeEventListener?.('change', on);
  }, [query]);
  return m;
}
